import React, { createContext, useEffect, useState } from "react";
import { imgMern } from "../../assets";

const PortofolioContext = createContext();

const PortofolioProvider = ({ children }) => {
  const [portofolio, setPortofolio] = useState([]);
  const [loading, setLoading] = useState(false);

  const getPortofolio = async () => {
    setLoading(true);
    try {
      const response = await [
        {
          id: 4,
          title: "CRUD MERN Stack",
          position: "Explorasi Web Developer",
          description:
            "Explorasi membangun aplikasi CRUD (Create, Read, Update, Delete) dengan MERN Stack (MongoDB, ExpressJS, ReactJS, NodeJS).",
          image: `${imgMern}`,
        },
      ];
      setPortofolio(response);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  useEffect(() => {
    getPortofolio();
  }, []);

  return (
    <PortofolioContext.Provider value={{ portofolio, loading }}>
      {children}
    </PortofolioContext.Provider>
  );
};

export { PortofolioContext, PortofolioProvider };
